export default {
  CURRENT_USER: 'currentUser',
  CURRENT_SERVICE_PROVIDER: 'currentServiceProvider',
};
